import type { FC } from 'react'
import TextField, { TextFieldProps } from '@mui/material/TextField'

const FFInput: FC<TextFieldProps> = props => {
  // A slot can be given as a callback, which carries no props to merge with, so
  // narrow before spreading the caller's own `input` slot over FFInput's styles.
  const callerSlotProps = props.slotProps ?? {}
  const callerInput =
    typeof callerSlotProps.input === 'function' ? undefined : callerSlotProps.input

  const input = {
    sx: {
      paddingLeft: '1em',
      paddingRight: '1em',
      bgcolor: 'blueGrey.lighter',
      transition: '100ms linear opacity',
      '&:before': { display: 'none' },
      '&:after': { borderColor: 'primary.main' },
      '&.Mui-disabled': { opacity: 0.75 },
      '& .MuiInputBase-input': { paddingTop: '0.75em', paddingBottom: '0.75em' },
      '&.MuiInputBase-multiline': { paddingTop: 0, paddingBottom: 0 },
    },
    ...callerInput,
  }

  // v4's default TextField variant was "standard"; v5 defaults to "outlined".
  // These styles target the standard variant's underline (`&:before`/`&:after`),
  // so pin the variant to keep the input's appearance unchanged. Callers can
  // still override via props.
  return <TextField variant="standard" {...props} slotProps={{ ...callerSlotProps, input }} />
}

export default FFInput
